import {BodyNode} from './services/BodyNode'
import {BodyConverter} from './services/BodyConverter'
import {BodyComponent} from './BodyComponent'

const BodyPackage = {
    name: 'body',
    configure: function(config) {
        config.addNode(BodyNode)
        config.addConverter(BodyConverter)
        config.addComponent('body', BodyComponent)
    }
}

export {BodyPackage}
